import sanitizeHtmlLibrary from "sanitize-html";

const allowedTags = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "blockquote", "hr",
  "h1", "h2", "h3", "h4", "h5", "h6", "ul", "ol", "li", "a", "img",
  "figure", "figcaption", "table", "thead", "tbody", "tfoot", "tr", "th", "td",
  "div", "span", "section", "details", "summary", "iframe",
];

export function sanitizeContentHtml(html: string | null | undefined) {
  return sanitizeHtmlLibrary(html ?? "", {
    allowedTags,
    allowedAttributes: {
      a: ["href", "title", "target", "rel"],
      img: ["src", "alt", "title", "width", "height", "loading", "style", "align"],
      iframe: ["src", "title", "width", "height", "allow", "allowfullscreen", "loading"],
      "*": ["class", "id", "data-block", "data-id", "data-source", "style"],
    },
    allowedStyles: {
      "*": {
        "float": [/^left$/, /^right$/, /^none$/],
        "display": [/^inline$/, /^block$/, /^inline-block$/, /^none$/],
        "margin": [/.*/],
        "margin-left": [/.*/],
        "margin-right": [/.*/],
        "margin-top": [/.*/],
        "margin-bottom": [/.*/],
        "text-align": [/.*/],
      },
    },
    allowedSchemes: ["http", "https", "mailto", "tel"],
    allowedIframeHostnames: ["www.youtube.com", "youtube.com", "player.vimeo.com"],
    transformTags: {
      a: (_tagName, attribs) => ({
        tagName: "a",
        attribs: {
          ...attribs,
          ...(attribs.target === "_blank" ? { rel: "noopener noreferrer" } : {}),
        },
      }),
      img: (_tagName, attribs) => ({
        tagName: "img",
        attribs: { ...attribs, loading: attribs.loading ?? "lazy", alt: attribs.alt ?? "" },
      }),
    },
    exclusiveFilter(frame) {
      return frame.tag === "iframe" && !frame.attribs.src;
    },
  });
}
